enum ExternalIntegrationSubmodule {
  // Acesso ao Elfa
  ELFA = 0x00000100,
  // Acesso ao BIM360
  BIM360 = 0x00000200,
}

export { ExternalIntegrationSubmodule };
